export default [
  { name: 'Blog', fee: 300, fullname: 'Blog', code: 'blog' },
  { name: 'Social Media', fee: 400, fullname: 'Social Media', code: 'social' },
  { name: 'Blog & Social Media', fee: 700, fullname: 'Blog & Social Media', code: 'blogsocial' }
]



// WEBPACK FOOTER //
// ./src/data/blogSocialItems.js